import { SET_PASSWORD, SET_EMAIL } from "./reducer";

export const setEmail = (email: string, error: string | null = null) => ({ type: SET_EMAIL, email, error });
export const setPassword = (password: string, error: string | null = null) => ({
    type: SET_PASSWORD,
    password,
    error,
});
